/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Editor_Token_LabelInputs */

const fr_settings_editor_token_label = /** @type {(inputs: Settings_Editor_Token_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeton d'authentification éditeur`)
};

const en_settings_editor_token_label = /** @type {(inputs: Settings_Editor_Token_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editor authentication token`)
};

/**
* | output |
* | --- |
* | "Editor authentication token" |
*
* @param {Settings_Editor_Token_LabelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_editor_token_label = /** @type {((inputs?: Settings_Editor_Token_LabelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Editor_Token_LabelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_settings_editor_token_label(inputs)
	return en_settings_editor_token_label(inputs)
});